import { getAccHostname } from '@adsk/acs-sc-web-platform-api';

const getRelativeAccountAdminURL = (accountId: string, isTemplate = false) => {
  const projectType = isTemplate ? 'templates' : 'projects';
  return `${getAccHostname()}/account-admin/${projectType}/accounts/${accountId}`;
};

export default getRelativeAccountAdminURL;
